module.exports = __webpack_public_path__ + "media/common/fonts/rs-plugin/revicons/revicons-e8746a624ed098489406e6113d185258.woff";